import { MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { getDetailsMinasAtivas } from 'services/detalhesMinasRequest';
import { CardWrapper, ErrorWrapper, ModalWrapper, SelectWrapper } from './styles';
import { IDetails } from 'contexts/@types/Map';

interface IFeaturesDetailsModal {
  processos: string[];
}

export function DetailsMinasModal({ processos }: IFeaturesDetailsModal) {

  const [detalhesProcessos, setDetalhesProcessos] = useState<IDetails[]>();

  const [selectedSubstancia, setSelectedSubstancia] = useState<string | null>(null);

  const [selectedUnidade, setSelectedUnidade] = useState<string | null>(null);

  const [selectedAno, setSelectedAno] = useState<string | null>(null);

  const [unidadesValues, setUnidadesValues] = useState<string[]>([]);
  const [anosValues, setAnosValues] = useState<number[]>([]);
  const [substanciasValues, setSubstanciasValues] = useState<string[]>([]);

  const dictUnidades: Record<string, string> = {
    'mg': 'Miligrama',
    'g': 'Grama',
    'kg': 'Quilograma',
    't': 'Tonelada',
  }

  useEffect(() => {
    const fetchDetails = async () => {
      const response = await getDetailsMinasAtivas<IDetails[]>(processos);
      setDetalhesProcessos(response.data);
    };
    if (processos.length > 0){
      fetchDetails();
      setSelectedSubstancia(null);
      setSelectedUnidade(null);
      setSelectedAno(null);
    }
  }, [processos]);

  function formatNumber(numero: number) {
    return new Intl.NumberFormat("pt-BR", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(numero);
  }

  function formatProcesso(processo: string) {
    const tokens = processo.split('/');
    tokens[0] = tokens[0].slice(0, tokens[0].length - 3) + "." + tokens[0].slice(-3);
    return tokens.join('/');
  }

  useEffect(() => {
    if (detalhesProcessos){
      setUnidadesValues(Array.from(new Set(detalhesProcessos.map((item: IDetails) => item.un_medida))));
      setAnosValues(Array.from(new Set(detalhesProcessos.map((item: IDetails) => item.ano))));
      setSubstanciasValues(Array.from(new Set(detalhesProcessos.map((item: IDetails) => item.substancia))))
    }
  }, [detalhesProcessos])

  function getCards() {
    if (!detalhesProcessos) return;
    const filteredProcessos = detalhesProcessos.filter((processo: IDetails) =>
      (!selectedSubstancia || processo.substancia === selectedSubstancia) &&
      (!selectedUnidade || processo.un_medida === selectedUnidade) &&
      (!selectedAno || processo.ano === Number(selectedAno))
    );
    if (filteredProcessos.length === 0) {
      return (
        <ErrorWrapper key={'not-found'}>
          Nenhum processo encontrado
        </ErrorWrapper>
      )
    }
    else {
      return filteredProcessos.map((processo: IDetails, index) => (
        <CardWrapper key={`${processo.processo_ano}_${processo.ano}_${processo.total_qt_comercializada}_${index}`}>
          <div className="title">
            {processo.ano} - {formatProcesso(processo.processo_ano)}
          </div>
          <div className="title">
            {processo.substancia}
          </div>
          <div className="values-wrapper">
            <div>
              Total Comercializado: {formatNumber(processo.total_qt_comercializada)} {processo.un_medida}
            </div>
            <div>
              Total Recolhido: R$ {formatNumber(processo.total_vl_recolhido)}
            </div>
          </div>
        </CardWrapper>
      ))
    }
  }

  return (
    <ModalWrapper>
      <SelectWrapper>
        <Select
          variant="standard"
          className='select'
          value={selectedSubstancia || " "}
          onChange={(e) => {
            e.target.value === ' '? setSelectedSubstancia(null) : setSelectedSubstancia(e.target.value);
          }}
          sx={{
            '&:before, &:after': {
              display: 'none',
            },
          }}
        >
          <MenuItem key={'default-option-select-substancia'} value={' '}> {'Substâncias'} </MenuItem>
          {detalhesProcessos && substanciasValues.map((substancia) => (
            <MenuItem key={`${substancia}_select`} value={substancia}>
              {substancia}
            </MenuItem>
          ))}
        </Select>

        <div className="sub-select-wrapper">
          <Select
            variant="standard"
            className='sub-select'
            value={selectedUnidade || " "}
            onChange={(e) => {
              e.target.value === ' '? setSelectedUnidade(null) : setSelectedUnidade(e.target.value);
            }}
            sx={{
              '&:before, &:after': {
                display: 'none',
              },
            }}
          >
            <MenuItem key={'default-option-select-unidade'} value={' '}> {'Unidade'} </MenuItem>
            {unidadesValues.map((unidade) => (
              <MenuItem key={`${unidade}_select`} value={unidade}>
                {dictUnidades[unidade.trim()]}
              </MenuItem>
            ))}
          </Select>
          <Select
            variant="standard"
            className='sub-select'
            value={selectedAno || " "}
            onChange={(e) => {
              e.target.value === ' '? setSelectedAno(null) : setSelectedAno(e.target.value);
            }}
            sx={{
              '&:before, &:after': {
                display: 'none',
              },
            }}
          >
            <MenuItem key={'default-option-select-ano'} value={' '}> {'Anos'} </MenuItem>
            {anosValues && anosValues.map((ano) => (
                <MenuItem key={ano} value={ano}>
                  {ano}
                </MenuItem>
              ))
            }
          </Select>
        </div>
      </SelectWrapper>

      {detalhesProcessos &&
        getCards()
      }

    </ModalWrapper>
  );
}
